import "./UserNotFound.scss";
import {Link} from "react-router-dom";
export default function UserNotFound() {
    return (
        <div className="user-not-found">
            <p className="message">Usuario no encontrado</p>
            <p>Es posible que el usuario no exista o que haya cambiado su nombre de usuario.</p>
            <Link to="/">Volver a la página principal</Link>
        </div>
    );
}